import * as types from '../types/ui'

const initialState = {
  headerMode: 'normal',
  alerts: {
    callback: null,
    isOpened: false,
    hasCancel: true,
    title: '',
    message: '',
    icon: '',
    type: ''
  },
  canRender: true,
  toolbarVisible: true,
  toaster: {
    isVisible: false,
    message: '',
    position: 'bottom-right',
    type: 'info'
  },
  popover: {
    isOpened: false,
    name: null
  },
  upload: {
    isSending: false,
    target: null
  },
  contextMenu: {
    show: false,
    top: 0,
    left: 0,
    data: {}
  },
  sidebar: {
    isOpened: false,
    name: null
  },
  pageOrder: {
    isOpened: false
  },
  fileManager: {
    callback: null,
    isOpened: false
  },
  lockBackground: {
    isVisible: false
  },
  forceupdate: Date.now(),
  saving: false,
  zoom: 1,
  zoomableInstance: null
}

export default function ( state = initialState, action ) {
  switch ( action.type ) {
  case types.SHOW_ALERT:
    return {
      ...state,
      alerts: {
        isOpened: true,
        ...action.payload
      }
    }

  case types.HIDE_ALERT:
    return {
      ...state,
      alerts: {
        callback: null,
        isOpened: false,
        hasCancel: true,
        title: '',
        message: '',
        icon: '',
        type: ''
      }
    }

  case types.HEADER_MODE:
    return {
      ...state,
      headerMode: action.payload
    }

  case types.SHOW_TOOLBAR:
    return {
      ...state,
      toolbarVisible: true
    }

  case types.HIDE_TOOLBAR:
    return {
      ...state,
      toolbarVisible: false
    }

  case types.SHOW_POPOVER:
    return {
      ...state,
      popover: {
        isOpened: true,
        name: action.payload
      }
    }

  case types.HIDE_POPOVER:
    return {
      ...state,
      popover: {
        name: null,
        isOpened: false
      }
    }

  case types.SET_UPLOADER_ACTIVE:
    return {
      ...state,
      upload: {
        isSending: action.payload.isSending,
        target: action.payload.target
      }
    }

  case types.SHOW_TOASTER:
    return {
      ...state,
      toaster: {
        isVisible: true,
        message: action.payload.message,
        position: action.payload.position,
        type: action.payload.type
      }
    }

  case types.HIDE_TOASTER:
    return {
      ...state,
      toaster: {
        isVisible: false,
        message: '',
        position: 'top-right',
        type: 'info'
      }
    }

  case types.SHOW_CONTEXT_MENU:
    return {
      ...state,
      contextMenu: {
        show: true,
        ...action.payload
      }
    }

  case types.HIDE_CONTEXT_MENU:
    return {
      ...state,
      contextMenu: {
        show: false,
        top: 0,
        left: 0
      }
    }

  case types.FORCE_UPDATE:
    return {
      ...state,
      forceupdate: Date.now()
    }

  case types.TOGGLE_SAVING:
    return {
      ...state,
      saving: action.payload
    }

  case types.TOGGLE_SIDEBAR:
    return {
      ...state,
      sidebar: {
        ...action.payload
      }
    }

    case types.TOGGLE_PAGE_ORDER:
      return {
        ...state,
        pageOrder: {
          ...action.payload
        }
      }

  case types.SHOW_FILE_MANAGER:
    return {
      ...state,
      fileManager: {
        ...action.payload
      }
    }

  case types.LOCK_BACKGROUND:
    return {
      ...state,
      lockBackground: {
        ...action.payload
      }
    }

  case types.SET_ZOOM:
    return {
      ...state,
      zoom: {
        ...state.zoom,
        ...action.payload
      }
    }

  case types.SET_ZOOMABLE_INSTANCE:
    return {
      ...state,
      zoomableInstance: action.payload
    }

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/ui.js